export default __webpack_public_path__ + "static/media/zertiassist_iconos_edit_24px.5a7217d0.svg";